// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-modal";

const rootElement = document.getElementById("root");
const modalRootElement = document.getElementById("modal-root");

// Ensure root element exists
if (!rootElement) {
  console.error("Root element (#root) not found in DOM");
}

// Bind react-modal to the app element
Modal.setAppElement(rootElement);

const root = createRoot(rootElement);
root.render(<App />);

const style = document.createElement("style");
style.innerHTML = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
  body {
    font-family: 'Inter', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`;
document.head.appendChild(style);